import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import PropTypes from 'prop-types';
import LoadingButton from '@mui/lab/LoadingButton';
import { useDispatch } from 'react-redux';

import { profitabilityResultCheck } from 'store/thunks/patientThunks';
import EligibilityFailureDialog from './EligibilityFailureDialog';

const EligibilityCheckProfitability = ({ mpi, requestId, requestLineItemId, onClose }) => {
  const [isProfitable, setIsProfitable] = useState(null);
  const [showFailDialog, setShowFailDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const handleCheckIsProfitable = () => {
    if (isProfitable === 'false') {
      return setShowFailDialog(true);
    }

    setIsLoading(true);

    const checkInput = {
      mpi,
      requestLineItemId,
      isProfitable: true,
    };

    return dispatch(profitabilityResultCheck({ mpi, requestId, checkInput })).then(() => {
      onClose();
      setIsLoading(false);
    });
  };

  const handleChangeRadio = (event) => {
    setIsProfitable(event.target.value);
  };

  const closeFailDialog = (_, reason) => {
    /* istanbul ignore next */
    if (reason !== 'backdropClick') {
      setShowFailDialog(false);
    }
  };

  const confirmFailureDialog = (formData) => {
    const checkInput = {
      isProfitable: false,
      mpi,
      requestLineItemId,
      failureReason: formData,
    };
    return dispatch(profitabilityResultCheck({ mpi, requestId, checkInput }));
  };

  return (
    <>
      <EligibilityFailureDialog
        confirmFailure={confirmFailureDialog}
        open={showFailDialog}
        onClose={closeFailDialog}
      />

      <Grid container>
        <FormControl>
          <Typography
            variant='h6'
            component={FormLabel}
            id='EligibilityActionItems-EligibilityCheckProfitability-radioSelect-group'
          >
            Is the claim profitable?
          </Typography>
          <Box sx={{ ml: 2, my: 2 }}>
            <RadioGroup
              aria-labelledby='EligibilityActionItems-EligibilityCheckProfitability-radioSelect-group'
              value={isProfitable}
              onChange={handleChangeRadio}
            >
              <FormControlLabel value control={<Radio />} label='Yes' />
              <FormControlLabel value={false} control={<Radio />} label='No' />
            </RadioGroup>
          </Box>
        </FormControl>
        <Grid container direction='row-reverse'>
          <LoadingButton
            loading={isLoading}
            variant='contained'
            disabled={!isProfitable}
            sx={{ width: 100 }}
            onClick={handleCheckIsProfitable}
          >
            Save
          </LoadingButton>
          <Button
            sx={{ mr: 2, width: 100 }}
            variant='outlined'
            color='secondary'
            size='medium'
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

EligibilityCheckProfitability.propTypes = {
  onClose: PropTypes.func.isRequired,
  mpi: PropTypes.string.isRequired,
  requestLineItemId: PropTypes.string.isRequired,
  requestId: PropTypes.string.isRequired,
};

export default EligibilityCheckProfitability;
